export const invoicesConstants = {
  GET_REQUEST: 'INVOICES_GET_REQUEST',
  GET_SUCCESS: 'INVOICES_GET_SUCCESS',
  GET_FAILURE: 'INVOICES_GET_FAILURE',
};
